module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', ["编辑名单"]), " ", _vm._h('span', {
    staticClass: "pull-right icon-right blue",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        _vm.selectAllOrCancel()
      }
    }
  }, [_vm._s(_vm.selectFlag)])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('div', {
    staticClass: "main-page roll-edit",
    staticStyle: {
      "padding-bottom": "60px"
    }
  }, [_vm._l((_vm.serviceList), function(item) {
    return (item.list.length > 0) ? _vm._h('div', [_vm._h('span', {
      staticClass: "margin-15 block"
    }, [_vm._s(item.typeName ? item.typeName : '未添加托管服务')]), " ", _vm._h('ul', {
      staticClass: "list-group-item primary"
    }, [_vm._l((item.list), function(student) {
      return _vm._h('li', {
        staticClass: "list-group"
      }, [_vm._h('div', {
        staticClass: "liner"
      }), " ", _vm._h('a', {
        staticClass: "group-link clearfix",
        attrs: {
          "href": "javascript:;"
        }
      }, [_vm._h('span', {
        staticClass: "img-wrap small pull-left"
      }, [_vm._h('img', {
        attrs: {
          "src": student.imageAddress ? (item.baseAcessPath + student.imageAddress) : _vm.img_default,
          "width": "100%"
        }
      })]), " ", _vm._h('span', {
        staticClass: "group-txt",
        staticStyle: {
          "padding": "0",
          "height": "40px"
        }
      }, [_vm._h('span', {
        staticClass: "block overhide"
      }, [_vm._h('cite', {
        staticClass: "font-16 pull-left"
      }, [_vm._s(student.studentName)]), " ", _vm._h('i', {
        staticClass: "img-sex",
        class: {
          'boy': student.sex == '男', 'girl': student.sex == '女'
        }
      }, [_vm._s(student.sex)])]), " ", _vm._h('cite', {
        staticClass: "gray"
      }, [_vm._s((student.grade ? student.grade : '') + (student.className ? student.className : ''))])]), " ", _vm._h('span', {
        staticClass: "pull-right checkbox-wrap"
      }, [_vm._h('i', {
        staticClass: "img-checkbox",
        class: {
          'checked': student.flag
        },
        on: {
          "click": function($event) {
            student.flag = !student.flag, _vm.selectedStudent()
          }
        }
      })])])])
    })])]) : _vm._e()
  })]), " ", _vm._h('div', {
    staticClass: "bottom-bar"
  }, [_vm._h('a', {
    staticClass: "button button-block button-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editRoll()
      }
    }
  }, ["好了，生成名单"])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-09e6c16a!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/rollcall/rollcallEdit.vue
// module id = 175
// module chunks = 1